export default "__VITE_ASSET__Yt7jWUa$__"